import {IBackendCaller} from "./backendCaller";
import {FileUrisResponse} from "../shared/interfaces/responses/fileUrisResponse";

const filesDefaultUrl = "/api/files";
const fileUrisDefaultUrl = "/api/fileUris";

export interface FileCreated {
  fileId: string;
}

export interface IFileService {
  uploadFile: (file: Blob, fileName: string) => Promise<any>;
  getFile: (
    fileId: string,
    width?: number,
    height?: number,
    abortController?: AbortController
  ) => Promise<any>;
  getFileUris: (
    ids: string[],
    width?: number,
    height?: number,
    ttl?: number,
    abortController?: AbortController
  ) => Promise<FileUrisResponse>;
}

export class FileService implements IFileService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  uploadFile = async (file: Blob, fileName: string) => {
    const formData = new FormData();
    formData.append("formFile", file);
    formData.append("fileName", fileName);
    return await this.backendCaller.callApi("POST", filesDefaultUrl, formData, {
      Accept: "application/json"
    });
  };

  getFile = async (
    fileId: string,
    width?: number,
    height?: number,
    abortController?: AbortController
  ) => {
    let extraParams = "";
    if (width && height) {
      extraParams = `?width=${width}&height=${height}`;
    }
    return await this.backendCaller.getFile(
      "GET",
      `${filesDefaultUrl}/${fileId}${extraParams}`,
      null,
      null,
      abortController
    );
  };

  getFileUris = async (
    ids: string[],
    width?: number,
    height?: number,
    ttl?: number,
    abortController?: AbortController
  ): Promise<FileUrisResponse> => {
    const nonEmptyIds = ids.filter(Boolean);
    if (nonEmptyIds.length === 0) {
      return {
        fileUris: []
      };
    }
    let extraParams = `?`;
    nonEmptyIds.forEach((id) => {
      extraParams += `&ids=${id}`;
    });
    if (width && height) {
      extraParams += `&width=${width}&height=${height}`;
    }
    if (ttl) {
      extraParams += `&ttl=${ttl}`;
    }
    return await this.backendCaller.callApi(
      "GET",
      `${fileUrisDefaultUrl}${extraParams}`,
      null,
      null,
      false,
      abortController
    );
  };
}
